var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 540",
    width: 960,
    height: 540,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 960,
    height: 540,
    fill: "#F1F3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 426L13.3 429.3C26.7 432.7 53.3 439.3 80 449.5C106.7 459.7 133.3 473.3 160 480C186.7 486.7 213.3 486.3 240 485C266.7 483.7 293.3 481.3 320 473.3C346.7 465.3 373.3 451.7 400 452.7C426.7 453.7 453.3 469.3 480 468.3C506.7 467.3 533.3 449.7 560 450.5C586.7 451.3 613.3 470.7 640 470.7C666.7 470.7 693.3 451.3 720 450.3C746.7 449.3 773.3 466.7 800 471C826.7 475.3 853.3 466.7 880 466C906.7 465.3 933.3 472.7 946.7 476.3L960 480L960 541L946.7 541C933.3 541 906.7 541 880 541C853.3 541 826.7 541 800 541C773.3 541 746.7 541 720 541C693.3 541 666.7 541 640 541C613.3 541 586.7 541 560 541C533.3 541 506.7 541 480 541C453.3 541 426.7 541 400 541C373.3 541 346.7 541 320 541C293.3 541 266.7 541 240 541C213.3 541 186.7 541 160 541C133.3 541 106.7 541 80 541C53.3 541 26.7 541 13.3 541L0 541Z",
    fill: "#0066FF",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveHaikei);
export default __webpack_public_path__ + "static/media/wave-haikei.0aaef1c0fdf1a2f2dbb9242a9c5d1b80.svg";
export { ForwardRef as ReactComponent };